import React from "react";
import * as CONTACT from "../../../content/pages/contact.json";
import { marked } from "marked";

export class Contact extends React.Component<{}, {}> {
  componentDidMount() {
    //   const markdown = require("../../../content/site" + name);
  }

  render() {
    const data = CONTACT;

    const markdownParsed = marked.parse(data.body);
    return (
      <div className="flex-1 relative flex flex-col pt-[230px]">
        <div
          className="custom flex flex-col max-w-[750px] ml-auto mr-auto"
          dangerouslySetInnerHTML={{ __html: markdownParsed }}
        ></div>
      </div>
    );
  }
}
